
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

type ExitModalProps = {
  show: boolean;
  onHide: () => void;
  onShow?: () => void;
};

const ExitModal: React.FC<ExitModalProps> = ({ show, onHide, onShow }) => {
  useEffect(() => {
    if (show && onShow) onShow();
  }, [show, onShow]);
  return (
  <Modal show={show} onHide={onHide} centered size="lg" className="exit-modal">
      <Modal.Header closeButton>
        <Modal.Title>Still have questions?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Let's talk. Contact customer service at{' '}
          <a href="tel:8884238700">(888) 423-8700</a>. Monday - Friday 8 a.m. - 8 p.m. EST.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default ExitModal;
